import {SurveySectionsRenderingModel} from "data/models/survey/base";
import {DESCRIPTION_CLASS, TITLE_CLASS} from "components/Survey/classes";

export const BusinessTypeTitle = ({businessName}: SurveySectionsRenderingModel) =>
    <span className={TITLE_CLASS}>What type of business is {businessName}?</span>;

export const BusinessDescriptionTitle = ({businessName}: SurveySectionsRenderingModel) =>
    <span className={TITLE_CLASS}>What is {businessName}?</span>;

export const BusinessDescriptionParagraph = ({businessName}: SurveySectionsRenderingModel) =>
    <div className={"mt-12 flex flex-col text-center max-w-screen-sm mx-auto"}>
      <div>
        <span className={"text-xl font-bold"}>We're saving your work</span>
      </div>
      <div>
        <span className={"text-base text-gray-500"}>
          Your answers will be saved as you go.
        </span>
      </div>
      <div>
        <span className={"text-base text-gray-500"}>
          You can return and finish or change your answers at any time.
        </span>
      </div>
    </div>;
